import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'

export const getHoverStyle = (): SerializedStyles => css`
  &:hover {
    border-color: ${Color.Black};
  }
`
